import React, {Component} from 'react';
import './DateSelectorView.css';
import leftArrow from '../images/arrow-left.png';
import rightArrow from '../images/arrow-right.png';
import moment from 'moment';
import DatePicker from 'react-datepicker';

export default class DateSelectorView extends Component{
    constructor(props){
        super(props);
        this.monthNames = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ];

        this.dayNames = [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ];

        this.state = {date:props.date};

        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);

        this._onChange(props.date);
    }
    getWeekRange(fromDate){
        let today = moment(fromDate);// || new Date();
        let weekStart = today.day(0).clone();// new Date(today.getTime());
        let weekEnd = today.day(6).clone();// new Date(today.getTime());

       /* weekStart.setDate(weekStart.getDate() - today.getDay());
        weekEnd.setDate(weekStart.getDate() + 6);
*/
        return [weekStart, weekEnd];

        //this.setState({weekRange:});
    }

    rangeToString(dateRange){
        let depth = 0;
        let endOrder = ['d', 'y'];
        let startOrder = ['m', 'd'];

        console.log("DateRaneToString:", dateRange)

        if(dateRange[0].month() != dateRange[1].month()){
            depth = 1;
            endOrder = ['m', 'd', 'y'];
        }

        if(dateRange[0].year() != dateRange[1].year()){
            endOrder = ['m', 'd', 'y'];
            startOrder = ['m', 'd', 'y'];
        }

        


        let start = this.dateToString(dateRange[0], 3, startOrder);
        let end = this.dateToString(dateRange[1], 3, endOrder);

        return start + " - " + end ;
    }

    dateToString(d, depth, order){
        //depth day(0), month(1), year(2);
        let depthOrder = ['d', 'm', 'y'];
        let odr = order || ['m', 'd', 'y'];
        let dpth = depth || odr.length;



        let s = [];
        for(let i=0; i < dpth; i++){
            let p = odr[i];
            if(p){
                switch(p){
                    case 'm':
                        s.push(d.format('MMMM') + ' ');
                    break;
                    case 'd':
                        s.push(d.format('D'));
                    break;
                    case 'y':
                        s.push(', ' + d.format('YYYY'));
                    break;
                }
            }else{
                break;
            }
        }

        return s.join('');
    }

    next(){

        let date = moment(this.state.date);

        if(this.props.mode == 'single'){
            date.add(1, 'day');
        }else{
            date.day(7)
        }
        //let weekEnd = moment(this.state.date);// this.getWeekRange(this.state.date)[1];
       //weekEnd.day(7);
       
        this.setDate(date);
        /*this.setState({date: date});
        this._onChange(date);        */
    }

    prev(){
        let date = moment(this.state.date);

        if(this.props.mode == 'single'){
            date.subtract(1, 'day');
        }else{
            date.day(-1)
        }
        //let weekStart = moment(this.state.date);// this.getWeekRange(this.state.date)[0];
        //weekStart.day(-1);
        
        this.setDate(date);
        /*this.setState({date: date});
        this._onChange(date);*/
    }

    _onChange(date){
        if(this.props.onChange){
            this.props.onChange(date);
        }
    }

    setDate = (date)=>{
        console.log('setDate:', date)
        let d = moment(date);
        this.setState({date: d});
        this._onChange(d);
    }

    getDate = () => {
        return moment(this.state.date);
    }

    toString(){
        switch(this.props.mode){
            case 'single':
                return moment(this.state.date).format('ddd, MMMM D, YYYY');
            break;
            default:
                let weekRange = this.getWeekRange(this.state.date);
                return this.rangeToString(weekRange);
            break;
        }
    }

    render(){
        return(
            <div className="date-selector-view">
                <DatePicker 
                    customInput={<span><span className="date-display">{this.toString()}</span></span>}
                    selected={ moment(this.state.date) }
                    onChange={this.setDate}
                />                
                <img src={leftArrow} onClick={this.prev} className="arrow" /> <span className='today-btn' onClick={()=> this.setDate() }>Today</span> <img src={rightArrow} onClick={this.next} className="arrow" />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/DateSelectorView.js